import { Box, Typography, styled } from '@material-ui/core';

export const ActionsContainer = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  gap: 8,
});

export const StatusText = styled(Typography)({
  fontFamily: 'Open Sans',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '24px',
  letterSpacing: '0.25px',
  textTransform: 'capitalize',
});
